exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#nfeventsapp{color:#000;margin-bottom:2em\n}", ""]);

// exports
